import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LoginSignup from '../views/LoginSignup.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'LoginSignupRoute',
    component: LoginSignup,
  },
  {
    path: '/challenge',
    name: 'Challenge',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/oauth/callback',
    name: 'OAuthCallbackView',
    component: () => import('../views/OAuthCallbackView'),
  },
  {
    path: '/oauth/in-app',
    name: 'OAuthInAppView',
    component: () => import('../views/AppEntry.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
